module.exports = __webpack_public_path__ + "img/icon-skip-start-active.f2a842e9.svg";